import { SyntheticEvent, FC, ReactNode, useCallback } from 'react';
import { SelectOption } from './components';
import { ISelectOption, TSelectValue } from 'shared/types/filters';

interface IDropdownSelect {
  options: ISelectOption[];
  value: TSelectValue;
  disabled?: boolean;
  postfix?: ReactNode;
  multiple?: boolean;

  onChange(value: TSelectValue, e: SyntheticEvent): void;
}

export const DropdownSelect: FC<IDropdownSelect> = ({ options, value, multiple, postfix, onChange }) => {
  const handleOptionClick = useCallback(
    (option: ISelectOption, event: SyntheticEvent<HTMLDivElement>) => {
      let newValue: TSelectValue;

      if (multiple) {
        if (Array.isArray(value)) {
          newValue = value.includes(option.value)
            ? value.filter(optionValue => optionValue !== option.value)
            : [...value, option.value];
        } else {
          newValue = [option.value];
        }
      } else {
        newValue = option.value;
      }

      onChange(newValue, event);
    },
    [multiple, onChange, value],
  );

  return (
    <div data-testid="DropdownSelect">
      {options.map((option, index) => (
        <SelectOption
          {...option}
          key={option.value}
          index={index}
          multiple={multiple}
          selected={Array.isArray(value) ? value.includes(option.value) : value === option.value}
          onClick={event => handleOptionClick(option, event)}
        />
      ))}

      {postfix}
    </div>
  );
};
